import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { SettingsNgUiModule } from '@quorum/settings-ng-ui';
import { ShaComponentsNgUiModule } from '@quorum/sha-components-ng-ui';
import { NgPipesModule } from 'ngx-pipes';
import { CommunicatorDialogEditorComponent } from './communicator-dialog-editor/communicator-dialog-editor.component';
import { CoreBodyEditorComponent } from './core-body-editor/core-body-editor.component';
import { DeleteTemplateDialogComponent } from './delete-template-dialog/delete-template-dialog.component';
import { DesignComponent } from './design/design.component';
import { FullEditorComponent } from './full-editor/full-editor.component';
import { GalleryComponent } from './gallery/gallery.component';
import { HomeComponent } from './home/home.component';
import { NewComponent } from './new/new.component';
import { PlaceholderDialogComponent } from './placeholder-dialog/placeholder-dialog.component';
import { QuorumGalleryComponent } from './quorum-gallery/quorum-gallery.component';
import { SendEmailPreviewDialogComponent } from './send-email-preview-dialog/send-email-preview-dialog.component';
import { SettingsComponent } from './settings/settings.component';
import { ShellComponent } from './shell/shell.component';
import { SlimEditorComponent } from './slim-editor/slim-editor.component';
import { QuorumFullEditorComponent } from './quorum-full-editor/quorum-full-editor.component';
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgPipesModule,
    CommonMaterialComponentsModule,
    MatSidenavModule,
    ShaComponentsNgUiModule,
    MatButtonToggleModule,
    SettingsNgUiModule,
  ],
  exports: [
    FullEditorComponent,
    ShellComponent,
    GalleryComponent,
    HomeComponent,
    DesignComponent,
    NewComponent,
    CoreBodyEditorComponent,
    CommunicatorDialogEditorComponent,
    QuorumGalleryComponent,
  ],
  declarations: [
    FullEditorComponent,
    ShellComponent,
    GalleryComponent,
    HomeComponent,
    PlaceholderDialogComponent,
    DesignComponent,
    NewComponent,
    DeleteTemplateDialogComponent,
    SlimEditorComponent,
    CoreBodyEditorComponent,
    CommunicatorDialogEditorComponent,
    SendEmailPreviewDialogComponent,
    SettingsComponent,
    QuorumGalleryComponent,
    QuorumFullEditorComponent,
  ],
})
export class XsrTemplateEditorNgUiModule {}
